import React from 'react';

const POS = () => {
  return (
    <iframe 
      src='https://checkout.square.site/merchant/ML2CN2CP8J201/checkout/FXUW57O7IMIQ4S3PETHDW4PL' 
      style={{ maxWidth: '100%', border: 0, height: '90vh', width: '90%', borderRadius: '20px' }} 
      title="POS System"
    ></iframe>
  );
};

export default POS;